var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('h1',[_vm._v("PAGE NOT FOUND - 404")])])
}
var staticRenderFns = []

export { render, staticRenderFns }